// extracted by mini-css-extract-plugin
module.exports = {"save-sign-detail":"save-sign-detail-c5d7fcd85fe5c79a81498c768ddae5be","pt-save-sign-detail":"pt-save-sign-detail-069a6c1eb35918f743f4cd7f10db6af6"};